import styled, { css, createGlobalStyle } from 'styled-components'
import { color } from 'ui/themes/utils'

const statusColors = {
  error: '--book-button-error-color'
}

export const HostStyles = createGlobalStyle`
  :host {
    --book-button-button-color: var(--color-accent-background, ${color('branding')});
    --book-button-button-label-color: var(--color-accent-foreground, ${color('white')});

    --secondary-button-button-color: var(--color-primary-background, ${color('white')});
    --secondary-button-button-label-color: var(--color-primary-foreground, ${color('Text/Primary')});
    --secondary-button-button-border: 1px solid var(--color-border, ${color('Misc/Divider')});

    --book-button-error-color: var(--color-red, ${color('Danger/Base')});

    --book-button-label-weight: 700;

    --book-button-input-border-radius: 6px;
    --book-button-button-border-radius: 6px;

    --book-button-control-height: 48px;

    --book-button-button-padding: 0 14px;
    --book-button-button-width: 100%;
  }

  * {
    box-sizing: border-box;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
`

export const Label = styled.span`
  color: var(--book-button-button-label-color);

  font-weight: var(--book-button-label-weight);
`

export const Overlay = styled.div`
  position: absolute;

  width: 100%;
  height: 100%;

  top: 0;
  left: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    max-height: 18px;
    max-width: 18px;

    height: 100%;
    width: 100%;

    &.loading {
      animation: spin 1s linear infinite;
    }
  }
`

export const Button = styled.button`
  display: block;
  position: relative;

  width: var(--book-button-button-width);
  height: var(--book-button-control-height);

  padding: var(--book-button-button-padding);

  background-color: var(--book-button-button-color);
  color: var(--book-button-button-label-color);

  border: none;
  border-radius: var(--book-button-button-border-radius);

  cursor: pointer;

  &:hover {
    box-shadow: inset 0px 0px 400px 110px rgba(0, 0, 0, 0.12);
  }

  transition: all 0.2s ease-in-out;

  ${({ loading }) =>
    loading &&
    css`
      cursor: progress;

      ${Label} {
        opacity: 0;
        visibility: hidden;
      }
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;

      opacity: 0.5;
    `}

  ${({ status }) =>
    status &&
    css`
      background-color: var(${statusColors[status]});

      ${Label} {
        opacity: 0;
        visibility: hidden;
      }
    `}

  ${({ secondary }) =>
    secondary &&
    css`
      background-color: var(--secondary-button-button-color);

      border: var(--secondary-button-button-border);

      ${Label} {
        color: var(--secondary-button-button-label-color);
      }
    `}
`
